import {useEffect, useContext} from "react";
import {useHistory, useLocation} from "react-router";
import {GlobalContext} from "../hoc/LayoutContext";
import {validateField} from "../utils/validation";
import {setTrackingDataAction} from "../containers/RegistrationLoginPage/actions";
import {REGISTRATION_LOGIN} from "../types";
import {useDispatch, useSelector} from "react-redux";
import {checkUrlIsExternal} from "../utils/url";
import {anchorLabelForExternalURL} from "../utils/string";

export const useAnchorForExternalLinks = (userLoggedIn) => {
    const {push} = useHistory();
    const {pathname} = useLocation();
    const context = useContext(GlobalContext);
    const {isScrolled} = context;
    const dispatch = useDispatch();
    const isMobile = useSelector((state) => state.layout.isMobile);

    const externalTrackingIdObj = useSelector(
        (state) => state.layout.currentExternalURLSignUpTrackingKey,
    );

    useEffect(() => {
        if (!userLoggedIn) {
            let documents;

            documents = document.querySelectorAll(`.wiki a[href]`);

            let anchorItems = [].slice.call(documents);
            let listeners = [];

            anchorItems.forEach((anchor) => {
                if (validateField(anchor, "object", "href", false)) {
                    const anchorHref = anchor.href;
                    if (checkUrlIsExternal(anchorHref)) {
                        let externalTrackingId = null;
                        if (isMobile) {
                            externalTrackingId = externalTrackingIdObj?.mobile ?? 0;
                        } else {
                            externalTrackingId = externalTrackingIdObj?.laptop ?? 0;
                        }
                        const clickHandleA = (event) => {
                            event.preventDefault();
                            dispatch(
                                setTrackingDataAction(
                                    {
                                        trackingId: externalTrackingId,
                                        ctaType: REGISTRATION_LOGIN,
                                        referralURL: anchorHref,
                                        referralTitle: "External URL",
                                    },
                                    REGISTRATION_LOGIN,
                                ),
                            );
                            push("/signup");
                        };

                        anchor.addEventListener("click", clickHandleA);
                        anchor.text = anchorLabelForExternalURL(anchorHref);
                        anchor.setAttribute("oncontextmenu", "return false");
                        listeners.push([anchor, clickHandleA]);
                    }
                }
            });
            return () => {
                listeners.forEach((arr) => {
                    arr[0].removeEventListener("click", arr[1]);
                });
            };
        }
    }, [push, isScrolled, pathname, dispatch, externalTrackingIdObj, userLoggedIn, isMobile]);
};
